module.exports = __webpack_public_path__ + "static/media/sweet_bonanza.pragmaticplay.2e8ead3a.jpeg";